export default "__VITE_ASSET__BXQOIZp9__"